import { useMemo } from "react";
import { LatLngExpression } from "leaflet";
import SpriteSvg from "../../components/common/svg";
import { MapMarker } from "./index";

const HomeMarker = ({ position }: { position: LatLngExpression }) => {

  const icon = () => {
    return(
      <div className="home-marker">
          <SpriteSvg id="map-location"/>
      </div>);
  }

  return (<MapMarker position={position} icon={icon()} />);

}

export default HomeMarker;
